module.exports = __webpack_public_path__ + "img/1529351494.b754bb7a.jpg";